import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NoInternet from "./NoInternet";
import Login from "./Admin/Login";
import Dashboard from "./Admin/Dashboard";
import Layout from "./Admin/Common/Layout";
import PrivateRoute from "./PrivateRoute";
import Profile from "./Admin/Profile";
import Password from "./Admin/Password";
import PrivacyPolicy from "./Admin/Cms/PrivacyPolicy";
import AboutUs from "./Admin/Cms/AboutUS";
import TermsConditions from "./Admin/Cms/TermsConditions";
import NotificationSend from "./Admin/Notifications/NotificationSend";
// import Chat from "./Admin/Chat/Chat";
import { SocketProvider } from "./Admin/context/SocketContext";
import { ToastContainer } from "react-toastify";
import { initOffcanvasBackButtonHandler } from "./Config";
import SellersList from "./Admin/Users/SellersList";
import BuyerList from "./Admin/Users/BuyerList";
import IntermediateList from "./Admin/Users/IntermediateList";
import Product from "./Admin/product/Product";
import IntermediateProducts from "./Admin/product/IntermediateProducts";
import ProductRequest from "./Admin/productRequest/ProductRequest";
import IntermediateRequests from "./Admin/productRequest/IntermediateRequests";
import Chat from "./Admin/Chat/Chat";

// import AddProduct from "./Admin/product/AddProduct";
import FaqList from "./Admin/Faqs/FaqList";
import AddFaq from "./Admin/Faqs/AddFaq";
import EditFaq from "./Admin/Faqs/EditFaq";
import ViewFaq from "./Admin/Faqs/ViewFaq";
import ContactList from "./Admin/Contact/ContactList";
import MatchList from "./Admin/MatchList/MatchList";

const App = () => {
  const isAuthenticated = localStorage.getItem("token");
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    const cleanup = initOffcanvasBackButtonHandler();

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
      cleanup();
    };
  }, []);

  if (!isOnline) {
    return <NoInternet />;
  }
  return (
    <>
      <SocketProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Layout />}>
              <Route
                path="/"
                element={<PrivateRoute element={<Dashboard />} />}
              />
              <Route
                path="/dashboard"
                element={<PrivateRoute element={<Dashboard />} />}
              />
              <Route
                path="/profile"
                element={<PrivateRoute element={<Profile />} />}
              />
              <Route
                path="/password"
                element={<PrivateRoute element={<Password />} />}
              />
              <Route
                path="/sellerlist"
                element={<PrivateRoute element={<SellersList />} />}
              />
              <Route
                path="/chat"
                element={<PrivateRoute element={<Chat />} />}
              />
               <Route
                 path="/buyerlist"
                 element={<PrivateRoute element={<BuyerList />} />}
               />
               <Route
                 path="/intermediatelist"
                 element={<PrivateRoute element={<IntermediateList />} />}
               />
                <Route
                 path="/productlist"
                 element={<PrivateRoute element={<Product />} />}
               />
                {/* <Route
                  path="/add-product"
                  element={<PrivateRoute element={<AddProduct />} />}
                /> */}
                <Route
                  path="/intermediateproducts"
                  element={<PrivateRoute element={<IntermediateProducts />} />}
                />
                <Route
                 path="/productRequestlist"
                 element={<PrivateRoute element={<ProductRequest />} />}
               />
               <Route
                 path="/intermediaterequests"
                 element={<PrivateRoute element={<IntermediateRequests />} />}
               />

              <Route
                path="/faqlist"
                element={<PrivateRoute element={<FaqList />} />}
              />
              <Route
                path="/addFaq"
                element={<PrivateRoute element={<AddFaq />} />}
              />
              <Route
                path="/editFaq/:id"
                element={<PrivateRoute element={<EditFaq />} />}
              />
              <Route
                path="/viewFaq/:id"
                element={<PrivateRoute element={<ViewFaq />} />}
              />
              <Route
                path="/contactlist"
                element={<PrivateRoute element={<ContactList />} />}
              />

              <Route
                path="/privacypolicy"
                element={<PrivateRoute element={<PrivacyPolicy />} />}
              />
              <Route
                path="/aboutus"
                element={<PrivateRoute element={<AboutUs />} />}
              />
              <Route
                path="/termsConditions"
                element={<PrivateRoute element={<TermsConditions />} />}
              />
              <Route
                path="/notification"
                element={<PrivateRoute element={<NotificationSend />} />}
              />
              <Route
                path="/chat"
                element={<PrivateRoute element={<Chat />} />}
              />
              <Route
                path="/matchlist"
                element={<PrivateRoute element={<MatchList />} />}
              />
            </Route>
          </Routes>
        </Router>
      </SocketProvider>
      <ToastContainer />
    </>
  );
};

export default App;
